module.exports = new __parcel__URL__("36_Critical_strike4.e8aad1bd.png").toString();